function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var module;
// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, node:true, es6:true*/
(function () {
  var is_node = typeof module == 'object' && module.exports && module.children;
  if (!is_node) ;else ;
  define(['/util/sprintf.js', '/util/util.js', '/util/url.js', '/util/version_util.js'], function (sprintf, zutil, zurl, version_util) {
    var E = {};
    var assign = Object.assign;
    E.get_root_domain = zurl.get_root_domain;
    E.get_root_url = url => {
      // XXX sergey: quick hack for trial in hola browser
      if (url == 'chrome://newtab/') return 'newtab';
      var n = (url || '').match(/^https?:\/\/([^/]+)(\/.*)?$/);
      if (!n || !n[1]) return null;
      return E.get_root_domain(n[1]);
    };
    E.find_rule = (rules, opt) => {
      if (!rules) return;
      for (var i in rules) {
        var r = rules[i];
        if (opt.name == r.name && (opt.type === undefined || opt.type == r.type) && (opt.md5 === undefined || opt.md5 == r.md5) && (opt.country === undefined || opt.country.toLowerCase() == r.country.toLowerCase())) {
          return r;
        }
      }
      return null;
    };
    E.gen_route_str = (route_opt, opt) => {
      opt = opt || {};
      if (route_opt.direct) return 'direct';
      var s = route_opt.country.toLowerCase(),
        r = [];
      if (route_opt.peer) r.push('peer');
      if (route_opt.pool) {
        r.push('pool' + (typeof route_opt.pool == 'string' ? '_' + route_opt.pool : ''));
      }
      if (!opt.no_algo && route_opt.algo) r.push(route_opt.algo);
      if (r.length) s += '.' + r.join(',');
      return s;
    };
    function ip_list_to_agents(ip_list) {
      return fix_zagent(Object.keys(ip_list).join(','));
    }
    function fix_zagent(s) {
      return s.replace(/.hola.org/g, '').replace(/zagent/g, 'za');
    }

    // XXX arik: mv to util?
    function pad(num, size) {
      return ('000' + num).slice(-size);
    }
    function time_str(d) {
      d = new Date(d);
      if (isNaN(d)) return '00:00:00.000';
      return pad(d.getUTCHours(), 2) + ':' + pad(d.getUTCMinutes(), 2) + ':' + pad(d.getUTCSeconds(), 2) + '.' + pad(d.getUTCMilliseconds(), 3);
    }
    E.events_enabled = false;
    E.events = [];
    E.events_n = {};
    E.reset_events = () => {
      E.events = [];
      E.events_n = {};
    };
    E.push_event = (name, opt) => {
      try {
        if (!E.events_enabled) return;
        if (E.events.length > 512) E.events.splice(0, E.events.length / 2);
        E.events.push({
          name,
          ts: Date.now(),
          opt
        });
        E.events_n[name] = (E.events_n[name] || 0) + 1;
      } catch (e) {
        console.error('push_event error %s', e && e.stack);
      }
    };
    E.enable_events_logging = enabled => {
      E.events_enabled = !!enabled;
      if (!enabled) E.reset_events();
    };
    E.get_event_n = e => E.events_n[e];
    E.events_to_str = () => {
      var a = [];
      E.events.forEach(e => {
        var s = time_str(e.ts) + ' ' + e.name,
          o = e.opt;
        switch (e.name) {
          case '>zgettunnels':
            s += sprintf(' %s%s', o.country, (o.exclude || []).length ? ' exclude ' + o.exclude.map(x => fix_zagent(x)).join(',') : '');
            break;
          case '<zgettunnels':
            s += sprintf(' %s%s', o.country, ' agents ' + ip_list_to_agents(o.ip_list));
            break;
          case 'set_rule':
            s += sprintf(' %s%s%s%s%s', o.name, o.enabled ? ' ' + o.country : ' off', o.del ? ' del' : '', o.src ? ' src ' + o.src : '', !o.full_vpn ? ' !full_vpn' : '', o.mode == 'unblock' ? '' : ' mode ' + o.mode);
            break;
          case '<verify_err':
            s += sprintf(' %s %s', o.host ? fix_zagent(o.host) : o.ip, ' ' + o.err);
            break;
          case '<verify':
            s += sprintf(' %s %s', o.host ? fix_zagent(o.host) : o.ip, o.rtt ? o.rtt + 'ms' : '!rtt');
            break;
          case '>verify':
            s += sprintf(' %s', o.host ? fix_zagent(o.host) : o.ip);
            break;
          case '>stuck':
          case '>stuck_long':
            break;
          case '<stuck_end':
            s += sprintf(' %sms', o.duration);
            break;
          case 'pac_miss':
            s += sprintf(' %s!=%s %s', o.req_ip, o.agent_ip, o.url);
            break;
          case 'pac_reload':
            s += sprintf(' after %ssec', (o.new_ts - o.init_ts) / 1000);
            break;
          case 'navgiate':
            s += sprintf(' tab %s %s', o.tab_id, o.url);
            break;
          case 'popup_render':
          case 'tpopup_render':
            break;
          case 'pac_slow':
            s += sprintf(' %dms %s', o.dur, (o.url || '').substr(0, 50));
            break;
          default:
            s += JSON.stringify(o) || '';
            break;
        }
        a.push(s);
      });
      a = a.reverse();
      return a.join('\n');
    };
    class Domain_tree {
      constructor() {
        this.clear();
      }
      *[Symbol.iterator]() {
        var parts = [];
        var _iterator = _createForOfIteratorHelper(Domain_tree.iterate_subtree(parts, this.tree)),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var item = _step.value;
            yield item;
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
      clear() {
        this.tree = {};
      }
      get_value(domain) {
        if (!domain) return;
        var parts = domain.split('.');
        var leaf = this.tree,
          value = leaf[Domain_tree.VALUE];
        for (var i = parts.length - 1; leaf && i >= 0; i--) {
          leaf = leaf[parts[i]];
          value = leaf && Domain_tree.VALUE in leaf ? leaf[Domain_tree.VALUE] : value;
        }
        return value;
      }
      set_value(domain, value) {
        if (!domain) return void (this.tree[Domain_tree.VALUE] = value);
        var parts = domain.split('.');
        var leaf = this.tree;
        for (var i = parts.length - 1; i >= 0; i--) leaf = leaf[parts[i]] = leaf[parts[i]] || {};
        leaf[Domain_tree.VALUE] = value;
      }
    }
    Domain_tree.VALUE = Symbol.for('value');
    Domain_tree.iterate_subtree = function* (parts, leaf) {
      if (Domain_tree.VALUE in leaf) yield [parts.slice().reverse().join('.'), leaf[Domain_tree.VALUE]];
      for (var key in leaf) {
        parts.push(key);
        var _iterator2 = _createForOfIteratorHelper(Domain_tree.iterate_subtree(parts, leaf[key])),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var item = _step2.value;
            yield item;
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
        parts.pop();
      }
    };
    E.Domain_tree = Domain_tree;
    E.get_site_key = (conf, ext_opt, root_url) => {
      var ext_ver = ext_opt.ext_ver;
      var sites = conf && conf.sites || {};
      return Object.keys(sites).find(k => {
        var v = sites[k];
        var urls = Array.isArray(v.root_url) ? v.root_url : [v.root_url];
        return urls.includes(root_url) && E.check_min_ver(ext_ver, v.min_ver);
      });
    };
    var get_match_fn = operator => {
      if (operator == 'gt') return (a, b) => a > b;
      if (operator == 'gte') return (a, b) => a >= b;
      if (operator == 'lt') return (a, b) => a < b;
      if (operator == 'lte') return (a, b) => a <= b;
      if (operator == 're') return (a, b) => new RegExp(b).test(a);
      if (operator == 'in' || operator == 'nin') {
        return (a, b) => {
          var found;
          if (!Array.isArray(b)) return false; // bad conf
          if (!Array.isArray(a)) found = b.includes(a);else found = b.some(i => a.includes(i));
          return operator == 'in' ? found : !found;
        };
      }
      if (operator == 'eq' || operator == 'neq') {
        return (a, b) => {
          var equal;
          if (!Array.isArray(a)) equal = a == b;else if (!Array.isArray(b)) equal = a.includes(b);else equal = b.every(i => a.includes(i));
          return operator == 'eq' ? equal : !equal;
        };
      }
      return (a, b) => false;
    };
    E.match_filter = (query, filter) => {
      if (!filter) return true;
      if (!query) return false;
      query = assign({}, query);
      for (var key in query) {
        if (key.endsWith('_ts') && query.now) query['since_' + key] = query.now - query[key];
      }
      for (var f_key in filter) {
        if (!f_key) continue;
        var m = f_key.match(/^(.*)_(gt|gte|lt|lte|in|nin|re|eq|neq)$/);
        var q_key = m ? m[1] : f_key;
        var operator = m ? m[2] : 'eq';
        // fix for filters like {signed_in: true}
        if (operator == 'in' && !Array.isArray(filter[f_key]) || operator == 'nin' && !Array.isArray(filter[f_key])) {
          q_key = f_key;
          operator = 'eq';
        }
        var op1 = void 0,
          op2 = void 0;
        if (q_key.endsWith('_ver') && /(gt|gte|lt|lte|eq|neq)/.test(operator)) {
          op1 = version_util.cmp(query[q_key], filter[f_key]);
          op2 = 0;
        } else {
          op1 = query[q_key];
          op2 = filter[f_key];
        }
        if (!get_match_fn(operator)(op1, op2)) return false;
      }
      return true;
    };
    var apply_conf_override = (site_conf, ext_opt) => {
      var ext_ver = ext_opt.ext_ver,
        install_ver = ext_opt.install_ver,
        install_ts = ext_opt.install_ts;
      var _site_conf = site_conf,
        override = _site_conf.override;
      site_conf = zutil.omit(site_conf, ['override']);
      if (!override) return site_conf;
      var versions = Object.keys(override).sort((a, b) => -version_util.cmp(a, b));
      var ver = versions.find(v => E.check_min_ver(ext_ver, v) && E.check_min_install_ver(install_ver, override[v].install_min_ver) && E.check_min_install_ts(install_ts, override[v].install_min_ts));
      if (ver) {
        site_conf = zutil.extend_deep(zutil.clone_deep(site_conf), zutil.omit(override[ver], ['install_min_ver', 'install_min_ts']));
      }
      return site_conf;
    };
    var apply_trial_conf_override = (tconf, ext_opt) => {
      var _tconf = tconf,
        override = _tconf.override;
      tconf = zutil.omit(tconf, ['override']);
      if (!override || !ext_opt) return tconf;
      var ext_ver = ext_opt.ext_ver,
        trial_state = ext_opt.trial_state,
        now = ext_opt.now;
      var first_start_ts = trial_state && trial_state.first_start_ts;
      // old ext verssions do not support override
      if (!first_start_ts || !now || version_util.cmp(ext_ver, '1.174.712') < 0) return tconf;
      var match_opt = assign({
        first_start_ts
      }, ext_opt);
      delete match_opt.trial_state;
      // XXX sergey: for backward compat. New versions should use since_* syntax
      match_opt.first_start = now - first_start_ts;
      // find last match
      var ov = override.slice().reverse().find(o => E.match_filter(match_opt, o.filter));
      if (ov) tconf = zutil.extend_deep(zutil.clone_deep(tconf), ov.conf);
      return tconf;
    };
    E.get_all_sites_conf = (conf, ext_opt) => {
      var ext_ver = ext_opt.ext_ver,
        install_ver = ext_opt.install_ver,
        install_ts = ext_opt.install_ts;
      var c = conf && conf.sites_default || {};
      if (!E.check_min_ver(ext_ver, c.min_ver) || !E.check_min_install_ver(install_ver, c.install_min_ver) || !E.check_min_install_ts(install_ts, c.install_min_ts)) {
        return;
      }
      return apply_conf_override(c, ext_opt);
    };
    E.get_specific_site_conf = (conf, ext_opt, root_url) => {
      var site_conf = zutil.get(conf && conf.sites, E.get_site_key(conf, ext_opt, root_url));
      if (site_conf) site_conf = apply_conf_override(site_conf, ext_opt);
      return site_conf;
    };
    E.get_site_conf = (conf, ext_opt, root_url, path, def) => {
      var site_conf = root_url && E.get_specific_site_conf(conf, ext_opt, root_url) || E.get_all_sites_conf(conf, ext_opt);
      return path ? zutil.get(site_conf, path, def) : site_conf;
    };
    E.get_trial_conf = (conf, ext_opt, root_url, path, def) => {
      var ext_ver = ext_opt.ext_ver;
      var tconf = E.get_site_conf(conf, ext_opt, root_url, 'trial');
      if (!tconf) return;
      var def_trial = zutil.get(E.get_all_sites_conf(conf, ext_opt), 'trial');
      if (tconf.all_sites_timer && !def_trial) tconf = zutil.omit(tconf, ['all_sites_timer']);
      // if all_sites_timer is enabled, we must use common trial conf for all
      // sites, but each site can have own skip_signin value
      if (tconf.all_sites_timer && def_trial) tconf = assign({}, tconf, zutil.omit(def_trial, ['skip_signin']));
      tconf = apply_trial_conf_override(tconf, ext_opt);
      var _tconf2 = tconf,
        time_ended_bonus = _tconf2.time_ended_bonus;
      if (time_ended_bonus && !E.check_min_ver(ext_ver, time_ended_bonus.min_ver)) {
        tconf = zutil.omit(tconf, ['time_ended_bonus']);
      }
      return path ? zutil.get(tconf, path, def) : tconf;
    };
    E.check_min_ver = (ext_ver, min_ver) => version_util.valid(min_ver) && version_util.cmp(ext_ver, min_ver) >= 0;
    E.check_min_install_ver = (install_ver, min_ver) => !min_ver || version_util.valid(min_ver) && version_util.cmp(install_ver, min_ver) >= 0;
    E.check_min_install_ts = (install_ts, ts) => !ts || +install_ts >= +ts;

    // browser-side twin of svc/lib/rmt_update.js:get_product/pick_version
    // (that one is node-only); see also svc/vpn/peer/util.js:parse_appid
    E.get_product = appid => {
      if (!appid) return undefined;
      if (appid.startsWith('win_hola.gaming.')) return 'gaming';
      if (appid.startsWith('win_hola.browser_and_vpn.')) return 'browser+vpn';
      if (appid.startsWith('win_hola.browser.')) return 'browser';
      return 'vpn';
    };
    E.pick_version = (versions, product, suffix) => {
      if (product == 'gaming') return versions[`gaming_${suffix}`] || versions.gaming_windows;
      // combined install ('browser+vpn'): match the newest install, since
      // the last product installed/upgraded overwrites the shared svc
      var keys = (product || 'browser+vpn').split('+');
      if (keys.length == 1) return versions[`${keys[0]}_${suffix}`];
      return keys.map(k => versions[`${k}_${suffix}`]).reduce((max, v) => version_util.cmp(v, max) > 0 ? v : max);
    };
    return E;
  });
})();